import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import TofuProduct from 'models/TofuProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState, textureOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'
import Select from 'react-select'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const TofuPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        Texture,
        OtherTexture,
        PackageSize,
        Organic,
      } = current
      setPackaging({
        category,
        subCategory,
        Texture: {
          value: Texture || '',
          label: Texture.length > 0 ? Texture : 'Texture',
        },
        OtherTexture,
        PackageSize,
        Organic: Organic ?? false,
      })
    } else if (!updating) {
      setCurrent(TofuProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.OtherTexture) {
        methods.setValue('OtherTexture', current.OtherTexture)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Texture {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          name="Texture"
          placeholder={'Select Texture'}
          options={textureOptions}
          onChange={([selected]) => {
            setSelect(selected, 'Texture')
            return selected
          }}
          control={methods.control}
          rules={{ required: true }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Texture"
            message={'⚠ Please select a texture.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        {current?.Texture === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Texture (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="OtherTexture"
              placeholder={'Other Texture'}
              defaultValue={packaging?.OtherTexture}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 30,
                  message: '⚠ Other Texture exceeds 30 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="OtherTexture"
                message={'Other Texture is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <br />
        <FormGroup>
          <p>
            <strong>Package Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="PackageSize"
            defaultValue={packaging.PackageSize}
            placeholder={'14 - 16 ounces'}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
              min: {
                value: 14,
                message: '⚠ Size is below the required 14 ounce minimum.',
              },
              max: {
                value: 16,
                message: '⚠ Size exceeds the 16 ounces allowed.',
              },
              required: {
                value: true,
                message: '⚠ Please enter product size.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="PackageSize"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          checked={packaging.Organic}
          control={methods.control}
        />
      </Col>
    </Row>
  )
}

export default TofuPackage
